import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"

import TextInput from "./text-input"

/**
 * An hidden/shown input component - displays either an input or any other node passed as child
 *
 * @param {node} children,
 * @param {string} value - initial input text,
 * @param {bool} isInputVisible - show/hide input,
 * @param {func} handleInputEnd - callback to process the input text,
 */
function EditableInput({
  children,
  value = "",
  isInputVisible = false,
  handleInputEnd,
}) {
  const inputRef = useRef()
  const [text, setText] = useState(value)

  useEffect(() => {
    if (isInputVisible) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isInputVisible])

  const handleClickOutside = e => {
    if (inputRef.current && !inputRef.current.contains(e.target)) {
      changeItemName(e)
    }
  }

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      changeItemName(e)
    }
  }

  const handleChange = e => {
    let newText = e.target.value
    setText(newText)
  }

  const changeItemName = () => {
    handleInputEnd(inputRef.current.value)
    setText("")
  }

  return (
    <>
      {isInputVisible ? (
        <TextInput
          ref={inputRef} // Set the Ref
          value={text} // Now input value uses local state
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          autoFocus
        />
      ) : (
        children
      )}
    </>
  )
}

EditableInput.propTypes = {
  children: PropTypes.node,
  handleInputEnd: PropTypes.func,
  isInputVisible: PropTypes.bool,
  value: PropTypes.string,
}

export default EditableInput
